import { gql } from 'graphql-request';

const UpdateYAxisMutation = gql`
  mutation UpdateYAxis(
    $story_id: ID!
    $dataset_id: ID!
    $name: String
    $field_order: Int
    $overrides_selected: Boolean
    $overrides_name: String
    $style_glow: Boolean
    $style_show_points: Boolean
    $style_stroke_color: String
    $style_stroke_opacity: Float
    $style_stroke_width: Int
    $style_fill_color: String
    $style_fill_opacity: Float
    $style_show_label: Boolean
    $style_label_font_size: Int
    $style_label_length: Int
    $style_label_position: [Float!]
    $style_label_text_align: String
  ) {
    update_y_axis(
      story_id: $story_id
      dataset_id: $dataset_id
      name: $name
      field_order: $field_order
      overrides_selected: $overrides_selected
      overrides_name: $overrides_name
      style_glow: $style_glow
      style_show_points: $style_show_points
      style_stroke_color: $style_stroke_color
      style_stroke_opacity: $style_stroke_opacity
      style_stroke_width: $style_stroke_width
      style_fill_color: $style_fill_color
      style_fill_opacity: $style_fill_opacity
      style_show_label: $style_show_label
      style_label_font_size: $style_label_font_size
      style_label_length: $style_label_length
      style_label_position: $style_label_position
      style_label_text_align: $style_label_text_align
    ) {
      __typename

      ... on dataset_metadata_y_axis {
        name
        field_order

        overrides {
          selected
          name
        }

        style {
          glow
          show_points

          stroke_color
          stroke_opacity
          stroke_width

          fill_color
          fill_opacity

          show_label
          label_font_size
          label_length
          label_position
          label_text_align
        }
      }

      ... on i_error {
        message
      }
    }
  }
`;

export default UpdateYAxisMutation;
